<template>
  <div>
    <v-col cols="12">
      <v-card>
        <v-tabs v-model="tab" background-color="primary" dark>
          <v-tab
            v-if="
              roles.update_crawled_product_info || roles.read_crawled_product
            "
          >
            Product Info
          </v-tab>
          <v-tab v-if="roles.update_crawled_product_design">
            Product Design
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item
            flat
            v-if="
              roles.update_crawled_product_info || roles.read_crawled_product
            "
          >
            <v-card>
              <template>
                <seller />
              </template>
            </v-card>
          </v-tab-item>
          <v-tab-item flat v-if="roles.update_crawled_product_design">
            <v-card>
              <template>
                <designer />
              </template>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-col>
  </div>
</template>

<script>
import seller from "./c-product-detail-seller";
import designer from "./c-product-detail-designer";

export default {
  name: "product-detail",
  components: {
    seller,
    designer,
  },
  created() {
    this.$root.$refs.productDetail = this;
  },
  data: () => ({
    tab: null,
    items: [
      { tab: "Product Info", value: "Marketing" },
      { tab: "Product Design", value: "Design" },
    ],
    roles: [],
  }),
  methods: {
    checkRoles(str) {
      var a = this.$root.$refs.App.hashCode(str);

      if (this.$cookies.get("roles") != null) {
        var role = this.$cookies.get("roles").split(",");
        var index = role.indexOf(a.toString());
        if (index != -1) return true;
        else return false;
      } else return false;
    },
  },
  async mounted() {
    this.roles = await this.$cookies.get("crawled_product");

    if (this.roles.read_crawled_product) {
      console.log("Detail Crawl Product");
    } else {
      this.$router.push("/not-authorized");
    }
  },
};
</script>

<style scoped>
</style>





